module.exports = __webpack_public_path__ + "img/marker_route.055b7056.svg";